/**
 * Cierre semanal (Fase 4). La "semana operativa" es la unidad de cierre:
 * solo UNA puede estar abierta a la vez (obc.semanas_operativas + filtered
 * unique index). El Corte A (miércoles) congela lo logrado y avanza obras;
 * la Foto B es un snapshot opcional sin cierre.
 */
/**
 * Hito de desembolso (Flujo de Desembolsos) que un sprint puede disparar al
 * completarse. Mismos códigos que `app.catalogo_hito` en ese sistema — la
 * relación sprint→hito se define acá (obc.sprints_catalogo.hito_desembolso);
 * el estado de cobro real vive en Flujo de Desembolsos, no acá.
 */
export const HITOS_DESEMBOLSO = [
    { codigo: 'FIRMA', nombre: 'Firma', color: '#0ea5e9' },
    { codigo: 'MUROS', nombre: 'Muros', color: '#f59e0b' },
    { codigo: 'REPELLOS', nombre: 'Repellos', color: '#a855f7' },
    { codigo: 'PISO_VENTANAS', nombre: 'Piso y Ventanas', color: '#10b981' },
    { codigo: 'ENTREGA', nombre: 'Entrega', color: '#ef4444' },
];
//# sourceMappingURL=Cierre.js.map